import React, { useState, useEffect } from "react";
import { Loader2, CheckCircle } from "lucide-react";

const useStatusIndicator = (status) => {
  const [visible, setVisible] = useState(false);
  const [icon, setIcon] = useState("loader");

  useEffect(() => {
    if (status === "Completed") {
      setIcon("check");
      setTimeout(() => {
        setVisible(false);
      }, 2000);
    } else if (status === "Uploading") {
      setIcon("loader");
      setVisible(true); // Show indicator when uploading
    } else if (status) {
      setIcon("loader");
      setVisible(true); // Show indicator for other statuses
    }
  }, [status]);

  const StatusIndicator = () => (
    <div
      className={`fixed top-0 z-50 left-1/2 transform -translate-x-1/2 transition-all duration-500 ease-in-out ${
        visible ? "translate-y-0" : "-translate-y-full"
      }`}
    >
      <div className="bg-green-500 text-white px-4 py-2 rounded-b-md shadow-md flex items-center space-x-2">
        {icon === "loader" && <Loader2 className="animate-spin" size={18} />}
        {icon === "check" && <CheckCircle size={18} />}
        <span className="font-medium text-sm">{status}</span>
      </div>
    </div>
  );

  return { StatusIndicator };
};

export default useStatusIndicator;
